import PropTypes from "prop-types";

import {
  isBirthday,
  isAnniversary,
  isValentinesDay,
  isMotherDay,
  isFatherDay,
  defaultValue,
} from "utils/calendarUtils";
import aniversaryDay from "assets/images/occasions/aniversaryDay.png";
import fathersDay from "assets/images/occasions/fathersDay.png";
import mothersDay from "assets/images/occasions/mothersDay.png";
import valentinesDay from "assets/images/occasions/valentinesDay.png";
import partyHat from "assets/images/party-hat.png";

import { DefaultOccasion, DefaultBirthday, ImageOccasion, ImageBirthday } from "./styles";

const Icon = ({ occasion = defaultValue }) => {
  const isDefaultBirthday = isBirthday(occasion);

  const getImage = () => {
    switch (true) {
      case isBirthday(occasion):
        return partyHat;
      case isAnniversary(occasion):
        return aniversaryDay;
      case isValentinesDay(occasion):
        return valentinesDay;
      case isMotherDay(occasion):
        return mothersDay;
      case isFatherDay(occasion):
        return fathersDay;
      default:
        return partyHat;
    }
  };

  const Container = isDefaultBirthday ? DefaultBirthday : DefaultOccasion;
  const Image = isDefaultBirthday ? ImageBirthday : ImageOccasion;

  return (
    <Container>
      <Image
        alt={occasion}
        src={getImage()}
        width={isDefaultBirthday ? 34 : 54}
        widthMobile={isDefaultBirthday ? 28 : 40}
      />
    </Container>
  );
};

Icon.propTypes = {
  occasion: PropTypes.string,
};

export default Icon;
